import React from 'react';
import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  courseId: number;
  onDataChange: () => Promise<void>;
  review: {
    id: number;
    type: string;
  };
}

const ReviewDelete = ({ courseId, onDataChange, review }: Props) => {
  const { messages } = useReduxState();

  const handleDelete = async () => {
    const response = await api.delete(
      `/admin/courses/${courseId}/answer-reviews/${review.id}`
    );
    if (!response.data || !response.data.success) return false;

    await onDataChange();
    return true;
  };

  const labels =
    review.type === 'review' || review.type === 'request-changes'
      ? {
          confirmText: messages.tasksDeleteReviewConfirm,
          confirmTitle: messages.tasksDeleteReview,
          successMessage: messages.tasksDeleteReviewSuccess
        }
      : {
          confirmText: messages.readerDiscussionDeleteCommentConfirm,
          confirmTitle: messages.readerDiscussionDeleteComment,
          successMessage: messages.readerDiscussionDeleteCommentSuccess
        };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.commonDelete}
      category="danger"
      confirmText={labels.confirmText}
      confirmTitle={labels.confirmTitle}
      onConfirm={handleDelete}
      successMessage={labels.successMessage}
    />
  );
};

export default ReviewDelete;
